var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "additional-pane" },
    _vm._l(_vm.list, function(project, index) {
      return _c(
        "div",
        { key: index, staticClass: "additional-pane-item" },
        [
          _c("div", { staticClass: "additional-title" }, [
            _c("span", [_vm._v(_vm._s(project.value.title))]),
            project.type == "input"
              ? _c("span", { staticClass: "choose-tip" }, [
                  project.value.isRequired
                    ? _c("span", [
                        project.value.isMultipleChoice
                          ? _c("span", [
                              _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s("必选") +
                                    _vm._s(project.value.minRequiredNum) +
                                    "，" +
                                    _vm._s("最多选") +
                                    _vm._s(project.value.maxMultipleChoiceNum) +
                                    "\n            "
                                )
                              ])
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s("必选") +
                                  "1\n          "
                              )
                            ])
                      ])
                    : _c("span", [
                        project.value.isMultipleChoice
                          ? _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s("最多选") +
                                  _vm._s(project.value.maxMultipleChoiceNum) +
                                  "\n          "
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s("最多选") +
                                  "1\n          "
                              )
                            ])
                      ])
                ])
              : _vm._e()
          ]),
          project.type != "input"
            ? _c(
                project.type === "radio" ? "RadioGroup" : "CheckboxGroup",
                {
                  tag: "component",
                  attrs: { disabled: project.disabled },
                  on: { "on-change": _vm.update },
                  model: {
                    value: project.checkValue,
                    callback: function($$v) {
                      _vm.$set(project, "checkValue", $$v)
                    },
                    expression: "project.checkValue"
                  }
                },
                _vm._l(project.value.items, function(item, key) {
                  return _c(project.type === "radio" ? "Radio" : "Checkbox", {
                    key: key,
                    tag: "component",
                    staticClass:
                      "am-margin-right-20 am-margin-top-10 am-vertical-align-top",
                    attrs: { label: key, custom: "", disabled: item.disabled },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var currentValue = ref.currentValue
                            return _c(
                              "div",
                              { staticClass: "am-flex am-flex-column" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "am-button-custom",
                                    class: {
                                      active: currentValue,
                                      disabled: item.isSoldOut || item.disabled
                                    }
                                  },
                                  [
                                    item.isSoldOut
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "additional-stock-icon"
                                          },
                                          [_vm._v("罄")]
                                        )
                                      : _vm._e(),
                                    _c("span", [_vm._v(_vm._s(item.name))]),
                                    _c(
                                      "span",
                                      { staticClass: "prefix-price-unit" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.currency) +
                                            _vm._s(item.price)
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                item.hasStock
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "am-text-center additional-stock-wrap",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.stopPreventDefault.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("span", [_vm._v("库存：")]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.stockNum))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                }),
                1
              )
            : _c(
                "div",
                { staticClass: "choiceList am-flex-wrap" },
                _vm._l(project.value.items, function(item, key) {
                  return _c(
                    "div",
                    {
                      key: key,
                      staticClass: "choiceList-list am-flex",
                      class: { disabled: item.isSoldOut || item.disabled }
                    },
                    [
                      item.num <= 0 || project.value.maxMultipleChoiceNum == 1
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "am-flex am-flex-column",
                                on: {
                                  click: function($event) {
                                    return _vm.clickNum(
                                      item,
                                      project.value,
                                      key,
                                      project
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "am-button-custom",
                                    class: {
                                      active:
                                        project.value.maxMultipleChoiceNum ==
                                          1 && item.num > 0,
                                      disabled:
                                        item.isSoldOut ||
                                        item.disabled ||
                                        (typeof item.stockDisabled ==
                                          "boolean" &&
                                          item.stockDisabled)
                                    }
                                  },
                                  [
                                    item.isSoldOut
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "additional-stock-icon"
                                          },
                                          [_vm._v(_vm._s("罄"))]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      { staticClass: "am-margin-right-xs" },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "prefix-price-unit" },
                                      [
                                        _vm._v(
                                          "+" +
                                            _vm._s(_vm.currency) +
                                            _vm._s(item.price)
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        : _c("div", { staticClass: "choice-item" }, [
                            _c("div", { staticClass: "choiceList-list-left" }, [
                              _c(
                                "span",
                                { staticClass: "name am-margin-right-xs" },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              _c(
                                "span",
                                { staticClass: "prefix-price-unit price name" },
                                [
                                  _vm._v(
                                    "+" +
                                      _vm._s(_vm.currency) +
                                      _vm._s(item.price)
                                  )
                                ]
                              ),
                              item.isSoldOut
                                ? _c("span", { staticClass: "sold" }, [
                                    _vm._v(_vm._s("售罄"))
                                  ])
                                : _vm._e()
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "choiceList-list-right am-flex am-flex-column am-flex-column-center"
                              },
                              [
                                _c("span", { staticClass: "input-control" }, [
                                  _c("div", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.num > 0,
                                        expression: "item.num > 0"
                                      }
                                    ],
                                    staticClass:
                                      "additional-sub-reduce am-icon-reduce",
                                    on: {
                                      click: function($event) {
                                        return _vm.reduceNum(
                                          item,
                                          project.value,
                                          key,
                                          project
                                        )
                                      }
                                    }
                                  }),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          item.num > 0 &&
                                          (!item.isSoldOut || !item.disabled),
                                        expression:
                                          "item.num > 0 && (!item.isSoldOut || !item.disabled)"
                                      }
                                    ],
                                    staticClass: "input-control-content",
                                    domProps: { value: item.num },
                                    on: {
                                      blur: function($event) {
                                        return _vm.numChange(
                                          item,
                                          project.value,
                                          $event,
                                          key,
                                          project
                                        )
                                      }
                                    }
                                  }),
                                  _c("div", {
                                    staticClass:
                                      "additional-add-plus am-icon-plus",
                                    class: {
                                      disabled:
                                        typeof item.stockDisabled ==
                                          "boolean" && item.stockDisabled
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.addNum(
                                          item,
                                          project.value,
                                          key,
                                          project
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]
                            )
                          ]),
                      item.hasStock && !item.isSoldOut
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "am-text-center additional-stock-wrap",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.stopPreventDefault.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s("库存") +
                                  "：" +
                                  _vm._s(item.stockNum) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                }),
                0
              )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6b2ac0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6b2ac0a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/business/Additional/Additional.vue
// module id = /7Qa
// module chunks = 0